export { default as withMemo } from './withMemo'
